import EmblaCarousel from 'embla-carousel';

export function initStepsLayout2Slider() {
    const sliderElement = document.querySelector('.js-steps-layout2-slider');

    if (!sliderElement) return;

    const viewport = sliderElement.querySelector('.embla__viewport');
    const dotsContainer = document.querySelector('.embla-stepsblock2-pagination');
    const prevBtn = document.querySelector('.c_swiper-stepsblock-prev');
    const nextBtn = document.querySelector('.c_swiper-stepsblock-next');

    function buildDots() {
        if (!dotsContainer || !embla) return;
        dotsContainer.innerHTML = '';
        embla.scrollSnapList().forEach((_, i) => {
            const dot = document.createElement('button');
            dot.className = 'swiper-pagination-bullet';
            dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
            dot.addEventListener('click', () => embla.scrollTo(i));
            dotsContainer.appendChild(dot);
        });
        updateDots();
    }

    function updateDots() {
        if (!dotsContainer || !embla) return;
        const index = embla.selectedScrollSnap();
        dotsContainer.querySelectorAll('.swiper-pagination-bullet').forEach((dot, i) => {
            dot.classList.toggle('swiper-pagination-bullet-active', i === index);
        });
    }

    const embla = EmblaCarousel(viewport, {
        align: 'start',
        slidesToScroll: 1,
        loop: false,
        dragFree: false,
    });

    buildDots();
    embla.on('select', updateDots);

    if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
    if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

    window.addEventListener('resize', () => {
        embla.reInit();
        buildDots();
    });
}
